import { render } from "./ExerciseDataStyleInput.vue?vue&type=template&id=56536d9c&scoped=true&ts=true"
import script from "./ExerciseDataStyleInput.vue?vue&type=script&lang=ts"
export * from "./ExerciseDataStyleInput.vue?vue&type=script&lang=ts"

import "./ExerciseDataStyleInput.vue?vue&type=style&index=0&id=56536d9c&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56536d9c"]])

export default __exports__